var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.37435 15.5846C6.76555 15.5846 7.08268 15.2675 7.08268 14.8763C7.08268 14.4851 6.76555 14.168 6.37435 14.168C5.98315 14.168 5.66602 14.4851 5.66602 14.8763C5.66602 15.2675 5.98315 15.5846 6.37435 15.5846Z",
    stroke: "#050409",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1673 15.5846C14.5585 15.5846 14.8757 15.2675 14.8757 14.8763C14.8757 14.4851 14.5585 14.168 14.1673 14.168C13.7761 14.168 13.459 14.4851 13.459 14.8763C13.459 15.2675 13.7761 15.5846 14.1673 15.5846Z",
    stroke: "#050409",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.708984 0.707031H3.54232L5.44065 10.1916C5.50542 10.5177 5.68284 10.8107 5.94183 11.0192C6.20082 11.2276 6.5249 11.3384 6.85732 11.332H13.7423C14.0747 11.3384 14.3988 11.2276 14.6578 11.0192C14.9168 10.8107 15.0942 10.5177 15.159 10.1916L16.2923 4.2487H4.25065",
    stroke: "#050409",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart11);
export default __webpack_public_path__ + "static/media/shopping-cart-11.728b595f28184c2f0eda1ee962253cca.svg";
export { ForwardRef as ReactComponent };